import Record from "./base"

export class Note extends Record {}
